import * as React from "react";
import { connect } from "react-redux";
import { StoreState } from "../../reducers/root-reducer";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";

import { ConnectedDateSelect } from "./date-select";
import { ConnectedAddReservationButton } from "./add-reservation-button";
import { ConnectedMobileMenu } from "./mobile-menu";

export interface DashboardItemsProps {}

interface State {}

interface ConnectedDashboardItemsProps extends WithStyles<typeof styles> {
	layout: "desktop" | "tablet" | "phone";
}

type Props = DashboardItemsProps & ConnectedDashboardItemsProps;

export class DashboardItems extends React.Component<Props, State> {
	public render() {
		const { classes, layout } = this.props;

		return (
			<React.Fragment>
				<ConnectedDateSelect />
				<div className={classes.flexExpand} />
				<ConnectedAddReservationButton />
				{layout === "phone" && <ConnectedMobileMenu />}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: StoreState) => ({
	layout: state.layout
});

const styles = (theme: Theme) =>
	createStyles({
		flexExpand: {
			flexGrow: 1
		}
	});

export const ConnectedDashboardItems = withStyles(styles)(
	connect(mapStateToProps)(DashboardItems)
);
